import React from "react";
import { Handle } from "reactflow"; // Removed Position import, we use string now
import { Box, Paper, Typography, Divider, Chip } from "@mui/material";
import PropTypes from "prop-types";

const SignOffNode = ({ data }) => {
  return (
    <Box sx={{ position: "relative" }}>
      {/* Dynamic Target Handle */}
      <Handle
        type="target"
        position={data.targetPosition} // <--- READ FROM DATA
        style={{ opacity: 0, border: "none" }}
      />

      <Paper
        onClick={data.onClick}
        elevation={0}
        sx={{
          // ... (Keep your existing Executive Card styles) ...
          width: "100%",
          minWidth: 180,
          textAlign: "left",
          backgroundColor: "#ffffff",
          borderLeft: "4px solid ",
          borderLeftColor: "primary.main",
          borderTop: "1px solid #e0e0e0",
          borderRight: "1px solid #e0e0e0",
          borderBottom: "1px solid #e0e0e0",
          borderRadius: "4px",
          cursor: data.onClick ? "pointer" : "default",
          transition: "all 0.2s ease",
          "&:hover": data.onClick
            ? {
                boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                transform: "translateY(-2px)",
              }
            : {},
        }}
      >
        <Box p={2}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 700, fontSize: "14px", color: "#344767", mb: 0.5 }}
          >
            {data.label}
          </Typography>
          {data.jobGroup && (
            <Typography
              variant="caption"
              sx={{
                textTransform: "uppercase",
                color: "#7b809a",
                fontSize: "14px",
                fontWeight: 500,
                display: "block",
                mb: 1,
              }}
            >
              {data.jobGroup}
            </Typography>
          )}
          <Divider sx={{ my: 1, opacity: 0.6 }} />
          <Box display="flex" justifyContent="flex-start" alignItems="center" gap={0.5}>
            <Typography variant="caption" color="text.secondary">
              FTE -
            </Typography>
            <Typography variant="caption" fontWeight="bold" color="#344767">
              {data.fte ?? 0}
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Dynamic Source Handle */}
      <Handle
        type="source"
        position={data.sourcePosition} // <--- READ FROM DATA
        style={{ opacity: 0, border: "none" }}
      />
    </Box>
  );
};

SignOffNode.propTypes = {
  data: PropTypes.shape({
    targetPosition: PropTypes.string.isRequired, // Add these
    sourcePosition: PropTypes.string.isRequired, // Add these
    label: PropTypes.string.isRequired,
    jobGroup: PropTypes.string,
    fte: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onClick: PropTypes.func,
  }).isRequired,
};

export default SignOffNode;
